import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import * as React from "react";
import useSchematic from "../../hooks/use_schematic";
import { useParams } from "react-router-dom";
import useBackend from "../../hooks/use_backend";
import { useQuery } from "@tanstack/react-query";
import { REACT_QUERY_KEYS } from "../../enums/react_query_key_enum";
import { fetchSiteData } from "../../scripts/api_v2/site_client";

export default function LinkDeviceModal({ open, setOpen, handleLinkAction }) {
  const { selectedNode } = useSchematic();
  const [device, setDevice] = React.useState("");
  const params = useParams();
  const backend = useBackend();

  let {
    data: siteData,
    error,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [REACT_QUERY_KEYS.SITE_DATA, backend.fetch, params.site_id],
    queryFn: () => fetchSiteData(backend.fetch, params.site_id),
    enabled: false, // sitePage will refresh the query
  });

  function handleSubmit() {
    handleLinkAction(device, selectedNode.device_id);
    setDevice("");
  }

  function handleUnlink() {
    handleLinkAction(undefined, selectedNode.device_id);
    setDevice("");
  }

  if (!selectedNode || !siteData) {
    return null;
  }

  const devs = Object.keys(siteData.devices);

  if (selectedNode.id === 0 && selectedNode.device_id === null) {
    return (
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="link-modal-title"
        aria-describedby="link-modal-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">{"Link grid meter"}</DialogTitle>
        <DialogContent>
          {devs.length > 0 ? (
            <TextField
              value={device}
              label="Device"
              select
              fullWidth
              sx={{ my: 2 }}
              onChange={(e) => setDevice(e.target?.value)}
            >
              {" "}
              {Object.entries(siteData.devices).map(([key, value]) => (
                <MenuItem key={key} value={key}>
                  [{key}] - {value?.name}
                </MenuItem>
              ))}
            </TextField>
          ) : (
            <Typography>No available devices to link</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={() => handleSubmit()} autoFocus>
            Link
          </Button>
        </DialogActions>
      </Dialog>
    );
  } else if (selectedNode.device_id === null) {
    return (
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="link-modal-title"
        aria-describedby="link-modal-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">{"Link device"}</DialogTitle>
        <DialogContent>
          {devs.length > 0 ? (
            <TextField
              value={device}
              label="Device"
              select
              fullWidth
              sx={{ my: 2 }}
              onChange={(e) => {
                setDevice(e.target?.value);
              }}
            >
              {" "}
              {Object.entries(siteData.devices).map(([key, value]) => (
                <MenuItem key={key} value={key}>
                  [{key}] - {value?.name}
                </MenuItem>
              ))}
            </TextField>
          ) : (
            <Typography>No available devices to link</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={() => handleSubmit()} autoFocus>
            Link
          </Button>
        </DialogActions>
      </Dialog>
    );
  } else {
    return (
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Unlink device"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to unlink this device?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={() => handleUnlink()} autoFocus>
            Unlink
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
